import ComplaintList from '@/components/Complaint/ComplaintList'
import ComplaintForm from '@/components/Complaint/ComplaintForm'
import ComplaintDetail from '@/components/Complaint/ComplaintDetail'

let ComplaintRouter = [{
  path: '/complaint',
  name: 'ComplaintList',
  component: ComplaintList,
  meta: {
    title: 'Réclamations',
    requiresAuth: true,
    authorizations: ['complaint_index', 'desktop_access']
  }
}, {
  path: '/complaint/new',
  name: 'ComplaintNew',
  component: ComplaintForm,
  meta: {
    title: 'Nouvelle réclamation',
    requiresAuth: true,
    authorizations: ['complaint_new', 'desktop_access']
  }
}, {
  path: '/complaint/:id/edit',
  name: 'ComplaintEdit',
  component: ComplaintForm,
  meta: {
    title: 'Modifier une réclamation',
    requiresAuth: true,
    authorizations: ['complaint_edit', 'desktop_access']
  }
}, {
  path: '/complaint/:id',
  name: 'ComplaintDetail',
  component: ComplaintDetail,
  meta: {
    title: 'Fiche réclamation',
    requiresAuth: true,
    authorizations: ['complaint_show', 'desktop_access']
  }
}]

export default ComplaintRouter



// WEBPACK FOOTER //
// ./src/components/Complaint/router.js